import { Dialog, IconButton, Stack, Typography } from '@mui/material';
import { generateClient } from 'aws-amplify/api';
import { Controller, useForm } from 'react-hook-form';
import { Schema } from '../../../../../amplify/data/resource';
import Button from '../../../../components/custom/Button';
import TextFieldUnderline from '../../../../components/custom/TextFieldUnderline';

interface FormValues {
  fullName: string;
  agentId: string;
  email: string;
  phone: string;
}

// @ts-ignore
type Agent = Schema['User']['type'];

const apiClient = generateClient<Schema>();

const Add = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const {
    handleSubmit,
    control,
    setValue,
    reset,
    setError,
    watch,
    formState: { errors },
  } = useForm<FormValues>({});

  const onSubmit = async (formData: FormValues) => {
    try {
      await apiClient.models.User.create({
        ...formData,
        role: 'agent',
      });
      console.log('Client created successfully');
      reset();
      onClose();
    } catch (error) {
      console.error('Failed to submit contact:', error);
    }
  };

  return (
    <Dialog
      open={open}
      maxWidth="lg"
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '35px',
        },
      }}
    >
      <Stack
        component="form"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        alignItems="center"
        spacing={3}
        sx={{
          '& .MuiDialog-paper': {
            padding: '60px',
            boxSizing: 'border-box',
            position: 'relative',
            overflow: 'hidden',
          },
          px: '40px',
          py: '70px',
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            zIndex: 1,
          }}
        >
          <img
            alt="close"
            src={'/assets/client/close.svg'}
            width="15"
            height="15"
            style={{ cursor: 'pointer' }}
          />
        </IconButton>

        <Typography fontSize="40px" fontWeight="700" fontFamily={'AlmoniDL'}>
          הוסף סוכן
        </Typography>

        <Stack spacing={1} sx={{ width: '300px' }}>
          <Controller
            name="fullName"
            control={control}
            rules={{ required: 'חובה למלא את השדה' }}
            render={({ field }) => (
              <TextFieldUnderline
                {...field}
                label="שם מלא"
                fullWidth
                required
                error={!!errors.fullName}
                helperText={errors.fullName?.message}
              />
            )}
          />
          <Controller
            name="agentId"
            control={control}
            rules={{ required: 'חובה למלא את השדה' }}
            render={({ field }) => (
              <TextFieldUnderline
                {...field}
                label="ת״ז"
                fullWidth
                required
                error={!!errors.agentId}
                helperText={errors.agentId?.message}
              />
            )}
          />
          <Controller
            name="phone"
            control={control}
            rules={{ required: 'חובה למלא את השדה' }}
            render={({ field }) => (
              <TextFieldUnderline
                {...field}
                label="טלפון"
                fullWidth
                required
                error={!!errors.phone}
                helperText={errors.phone?.message}
              />
            )}
          />
          <Controller
            name="email"
            control={control}
            rules={{ required: 'חובה למלא את השדה' }}
            render={({ field }) => (
              <TextFieldUnderline
                {...field}
                label="מייל"
                fullWidth
                required
                error={!!errors.email}
                helperText={errors.email?.message}
              />
            )}
          />
        </Stack>
        <Button type="submit" fullWidth>
          שמירה
        </Button>
      </Stack>
    </Dialog>
  );
};

export default Add;
